import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILibrary, ILibraryListReqBody, IInitState } from "../interfaces";
import { getItem } from "utils/helpers";

const libraryFilters = getItem("libraryFilters");

const initialState = {
  loading: false,
  data: [],
  error: "",
  filtersData: libraryFilters ? libraryFilters : "",
};

const libraryVideoListSlice = createSlice({
  name: "libraryVideoList",
  initialState,
  reducers: {
    libraryVideoListRequest(
      state: IInitState,
      action: PayloadAction<ILibraryListReqBody>
    ) {
      state.loading = true;
      state.filtersData = action.payload;
    },
    libraryVideoListSuccess(
      state: IInitState,
      action: PayloadAction<ILibrary[]>
    ) {
      state.loading = false;
      state.data = action.payload;
    },
  },
});

export const { libraryVideoListRequest, libraryVideoListSuccess } =
  libraryVideoListSlice.actions;
export default libraryVideoListSlice.reducer;
